import { TableCell } from 'ui/tableCell/TableCell';
import { Delete } from 'ui/icons/action/Delete';
import { GhostButton } from 'ui/button';
import type { ModalContextState } from 'utils/contexts/modal';
import { FlexSpacer } from 'ui/flexSpacer';
import { LeftTooltip } from 'ui/tooltip/Tooltip';
import type { FacebookIntegrationTableColumnData } from './types';
import type { FacebookIntegrationsState } from './contexts/FacebookIntegrationContext';
import type { FacebookModalState } from './domain/modal';
import type { FacebookIntegration } from './domain/facebook';

export const convertRedirectPath = (path: string) => {
  const { origin: currentOrigin } = window.location;
  const originalOrigin = 'https://www.app.iterable.com';
  const newPath = path.replace(originalOrigin, currentOrigin);
  return newPath;
};

export const configureTableColumns = (
  targetId: FacebookIntegrationsState['targetId'],
  showModal: ModalContextState<FacebookModalState>['showModal'],
): FacebookIntegrationTableColumnData[] => {
  return [
    {
      name: 'ID',
      align: 'flex-start',
      value: 'id',
      sortable: false,
      RowCell: ({ row }) => <TableCell>{row.config.id}</TableCell>,
    },
    {
      name: 'Integration',
      align: 'flex-start',
      value: 'analyticsProvider',
      sortable: false,
      RowCell: ({ row }) => <TableCell>{row.config.adAccountId}</TableCell>,
    },
    {
      name: '',
      align: 'flex-end',
      value: '',
      sortable: false,
      RowCell: ({ row }) => (
        <FlexSpacer justifyContent="flex-end">
          <LeftTooltip tooltipContent={`Delete integration with id: ${row.config.id}`}>
            <GhostButton
              data-test={`deleteFacebookIntegration-${row.config.id}`}
              onClick={() => {
                targetId(row.config.id);
                showModal({ id: row.config.id });
              }}
            >
              <Delete height={20} />
            </GhostButton>
          </LeftTooltip>
        </FlexSpacer>
      ),
    },
  ];
};

export const facebookIntegrationsFilterFn = (integration: FacebookIntegration, filter: string) => {
  return (
    integration.config.adAccountId.toLowerCase().includes(filter.toLowerCase()) ||
    integration.config.id.toString().includes(filter)
  );
};
